import React from "react";
import styled from "styled-components";
import { ReactComponent as PasswordEyeHideActive } from "../../assets/images/eye-On.svg";

import WarnIcon from "./../../assets/images/trash.svg";
import * as Formatter from "../../utils/Formatter";
import UserContext from "../../contexts/UserContext";
import LayoutContext from "../../contexts/LayoutContext";
import * as Library from "../../utils/Library";
import AppContext from "../../contexts/AppContext";
import { transformData } from "../../utils/AddToCartDataFormatter";

const CheckoutItemCardStyles = styled.div`
    .product-item-card,
    .product-item-card * {
        box-sizing: border-box;
    }
    .product-item-card {
        background: var(--surface-surface-appcard, #1e2125);
        border-radius: 16px;
        padding: 8px;
        display: flex;
        flex-direction: column;
        gap: 12px;
        align-items: flex-start;
        justify-content: flex-start;
        flex-shrink: 0;
        position: relative;
        box-shadow: var(--60-24-card-box-shadow, 0px 24px 60px 0px rgba(0, 0, 0, 0.08));
    }
    .image2 {
        background: linear-gradient(-13.49deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.4) 50%);
        border-radius: 5px;
        align-self: stretch;
        flex-shrink: 0;
        height: 390px;
        position: relative;
        overflow: hidden;
    }

    .chips {
        background: var(--buttons-button-transparent-adaptive, rgba(0, 0, 0, 0.3));
        border-radius: 52px;
        padding: var(--spacings-md, 12px) var(--spacings-sm, 8px) var(--spacings-md, 12px) var(--spacings-sm, 8px);
        display: flex;
        flex-direction: row;
        gap: var(--spacings-sm, 8px);
        align-items: center;
        justify-content: center;
        height: 32px;
        position: absolute;
        right: 8px;
        bottom: 8.01px;
        backdrop-filter: blur(5px);
        z-index: 1;
    }
    .x-1 {
        color: var(--text-text-primary, #ffffff);
        text-align: center;
        font-family: var(--buttons-buttontext-font-family, "OpenSans-Regular", sans-serif);
        font-size: var(--buttons-buttontext-font-size, 14px);
        line-height: var(--buttons-buttontext-line-height, 18px);
        font-weight: var(--buttons-buttontext-font-weight, 400);
        position: relative;
    }
    .chips2 {
        background: var(--buttons-button-transparent-adaptive, rgba(0, 0, 0, 0.3));
        border-radius: 52px;
        padding: var(--spacings-md, 12px) var(--spacings-sm, 8px) var(--spacings-md, 12px) var(--spacings-sm, 8px);
        display: flex;
        flex-direction: row;
        gap: var(--spacings-sm, 8px);
        align-items: center;
        justify-content: center;
        height: 32px;
        position: absolute;
        left: 8px;
        bottom: 8px;
        backdrop-filter: blur(5px);
        z-index: 1;
    }
    .ellipse-243 {
        background: #f3ede7;
        border-radius: 50%;
        border-style: solid;
        border-color: var(--border-border-primary, rgba(166, 166, 166, 0.2));
        border-width: 2px;
        flex-shrink: 0;
        width: 20px;
        height: 20px;
        position: relative;
    }
    .m {
        color: var(--text-text-primary, #ffffff);
        text-align: left;
        font-family: var(--buttons-buttontext-font-family, "OpenSans-Regular", sans-serif);
        font-size: var(--buttons-buttontext-font-size, 14px);
        line-height: var(--buttons-buttontext-line-height, 18px);
        font-weight: var(--buttons-buttontext-font-weight, 400);
        position: relative;
    }
    .frame-295922389 {
        display: flex;
        flex-direction: column;
        gap: 0px;
        align-items: flex-end;
        justify-content: center;
        height: 15px;
        position: absolute;
        left: 0px;
        top: 0px;
    }
    .samsoe-samsoe-logo-white-3 {
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
        object-fit: contain;
        height: 100%;
        width: 100%;
    }
    .frame-295922778 {
        display: flex;
        flex-direction: column;
        gap: 14px;
        align-items: flex-end;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-295922816 {
        display: flex;
        flex-direction: column;
        gap: 12px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        height: 37px;
        position: relative;
    }
    .frame-295922869 {
        display: flex;
        flex-direction: column;
        gap: 8px;
        align-items: flex-start;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        height: 14px;
        position: relative;
    }
    .frame-295922870 {
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        justify-content: space-between;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .product-name {
        color: var(--text-text-primary, #ffffff);
        text-align: left;
        font-family: "OpenSans-Regular", sans-serif;
        font-size: 14px;
        line-height: 14px;
        font-weight: 400;
        position: relative;
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }
    .frame-295922854 {
        display: flex;
        flex-direction: row;
        gap: 12px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .price {
        color: var(--text-text-secondary, #8c8c8c);
        text-align: left;
        font-family: "OpenSans-Regular", sans-serif;
        font-size: 14px;
        line-height: 18px;
        font-weight: 400;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }
    ._1-500-nok {
        text-align: right;
        position: relative;
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }
    ._1-500-nok-span {
        color: var(--text-text-primary, #ffffff);
        font-family: "OpenSans-SemiBold", sans-serif;
        font-size: 16px;
        line-height: 22px;
        font-weight: 600;
    }
    ._1-500-nok-span2 {
        color: #ffffff;
        font-family: var(--text-primarytext-font-family, "OpenSans-Regular", sans-serif);
        font-size: var(--text-primarytext-font-size, 16px);
        line-height: var(--text-primarytext-line-height, 22px);
        font-weight: var(--text-primarytext-font-weight, 400);
    }
    ._1-500-nok-span3 {
        color: var(--text-text-secondary, #8c8c94);
        font-family: "OpenSans-Regular", sans-serif;
        font-size: 12px;
        line-height: 17px;
        font-weight: 400;
    }
    .frame-295922872 {
        display: flex;
        flex-direction: row;
        gap: 12px;
        align-items: flex-start;
        justify-content: flex-end;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .btn-mini {
        background: var(--buttons-button-quaternary, rgba(166, 166, 166, 0.1));
        border-radius: 52px;
        padding: 4px 16px 4px 16px;
        display: flex;
        flex-direction: row;
        gap: 4px;
        align-items: center;
        justify-content: center;
        flex: 1;
        height: 32px;
        position: relative;
        cursor: pointer;
    }
    .eye {
        flex-shrink: 0;
        width: 12px;
        height: 12px;
        position: relative;
        overflow: visible;
    }
    .button {
        color: var(--text-text-primary, #ffffff);
        text-align: left;
        font-family: var(--buttons-buttontext-font-family, "OpenSans-Regular", sans-serif);
        font-size: var(--buttons-buttontext-font-size, 14px);
        line-height: var(--buttons-buttontext-line-height, 18px);
        font-weight: var(--buttons-buttontext-font-weight, 400);
        position: relative;
        cursor: pointer;
    }
    .frame-29476 {
        flex-shrink: 0;
        width: 32px;
        height: 32px;
        position: relative;
        cursor: pointer;
    }
    .ellipse-86 {
        background: var(--wrap-wrap-red, rgba(255, 0, 0, 0.1));
        border-radius: 50%;
        width: 32px;
        height: 32px;
        position: absolute;
        left: 0px;
        top: 0px;
        backdrop-filter: blur(15px);
    }
    .frame-29475 {
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: center;
        width: 20px;
        height: 18px;
        position: absolute;
        left: calc(50% - 10px);
        top: calc(50% - 9px);
    }
    .trash-03 {
        flex-shrink: 0;
        width: 18px;
        height: 18px;
        position: relative;
        overflow: visible;
    }
    .rectangle-231 {
        background: var(--color-status-red-100, #ff0000);
        border-radius: 0px 8px 0px 10px;
        width: 45px;
        height: 21px;
        position: absolute;
        right: -2px;
        top: -0.01px;
    }
    ._30 {
        color: #ffffff;
        text-align: center;
        font-family: "OpenSans-SemiBold", sans-serif;
        font-size: 14px;
        line-height: 0px;
        font-weight: 600;
        position: absolute;
        right: 4px;
        top: 10.99px;
    }
    .discountPrice {
        font-size: 14px;
        font-weight: 400;
        color: #ff0000;
        text-decoration: line-through;
    }
`;
const MultipleCheckoutItemCardStyles = styled.div`
    .frame-29737,
    .frame-29737 * {
        box-sizing: border-box;
    }
    .frame-29737 {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: flex-start;
        justify-content: flex-start;
        flex-shrink: 0;
        position: relative;
        overflow-y: auto;
    }

    .frame-295922868 {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: flex-start;
        justify-content: flex-start;
        flex-shrink: 0;
        position: relative;
        width: 100%;
    }
    .frame-295922871 {
        display: flex;
        flex-direction: row;
        gap: 16px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .product-item-card {
        background: var(--surface-surface-appcard, #1e2125);
        border-radius: 16px;
        padding: 8px;
        display: flex;
        flex-direction: column;
        gap: 12px;
        align-items: flex-start;
        justify-content: flex-start;
        flex: 1;
        position: relative;
        box-shadow: var(--60-24-card-box-shadow, 0px 24px 60px 0px rgba(0, 0, 0, 0.08));
    }
    .image {
        background: linear-gradient(-13.49deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.4) 50%);
        border-radius: 8px;
        align-self: stretch;
        flex-shrink: 0;
        height: 209px;
        position: relative;
        overflow: hidden;
    }

    .chips3 {
        background: var(--buttons-button-transparent-adaptive, rgba(0, 0, 0, 0.3));
        border-radius: 52px;
        padding: var(--spacings-md, 12px) var(--spacings-sm, 8px) var(--spacings-md, 12px) var(--spacings-sm, 8px);
        display: flex;
        flex-direction: row;
        gap: var(--spacings-sm, 8px);
        align-items: center;
        justify-content: center;
        height: 32px;
        position: absolute;
        right: 8px;
        bottom: 8.01px;
        backdrop-filter: blur(5px);
        z-index: 1;
    }
    .x-1 {
        color: var(--text-text-primary, #ffffff);
        text-align: center;
        font-family: var(--buttons-buttontext-font-family, "OpenSans-Regular", sans-serif);
        font-size: var(--buttons-buttontext-font-size, 14px);
        line-height: var(--buttons-buttontext-line-height, 18px);
        font-weight: var(--buttons-buttontext-font-weight, 400);
        position: relative;
    }
    .chips4 {
        background: var(--buttons-button-transparent-adaptive, rgba(0, 0, 0, 0.3));
        border-radius: 52px;
        padding: var(--spacings-md, 12px) var(--spacings-sm, 8px) var(--spacings-md, 12px) var(--spacings-sm, 8px);
        display: flex;
        flex-direction: row;
        gap: var(--spacings-sm, 8px);
        align-items: center;
        justify-content: center;
        height: 32px;
        position: absolute;
        left: 8px;
        bottom: 8px;
        backdrop-filter: blur(5px);
        z-index: 1;
    }
    .ellipse-243 {
        background: #f3ede7;
        border-radius: 50%;
        border-style: solid;
        border-color: var(--border-border-primary, rgba(166, 166, 166, 0.2));
        border-width: 2px;
        flex-shrink: 0;
        width: 20px;
        height: 20px;
        position: relative;
    }
    .m {
        color: var(--text-text-primary, #ffffff);
        text-align: left;
        font-family: var(--buttons-buttontext-font-family, "OpenSans-Regular", sans-serif);
        font-size: var(--buttons-buttontext-font-size, 14px);
        line-height: var(--buttons-buttontext-line-height, 18px);
        font-weight: var(--buttons-buttontext-font-weight, 400);
        position: relative;
    }
    .frame-295922389 {
        display: flex;
        flex-direction: column;
        gap: 0px;
        align-items: flex-end;
        justify-content: center;
        height: 100%;
        width: 100%;
        position: absolute;
        left: 0px;
        top: 0px;
    }
    .samsoe-samsoe-logo-white-3 {
        align-self: stretch;
        flex-shrink: 0;
        height: 100%;
        position: relative;
        object-fit: cover;
        width: 100%;
    }
    .frame-295922778 {
        display: flex;
        flex-direction: column;
        gap: 14px;
        align-items: flex-end;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-295922816 {
        display: flex;
        flex-direction: column;
        gap: 12px;
        align-items: flex-start;
        justify-content: flex-start;
        flex-shrink: 0;
        width: 162px;
        height: 37px;
        position: relative;
        width: 100%;
    }
    .frame-295922869 {
        display: flex;
        flex-direction: column;
        gap: 8px;
        align-items: flex-start;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        height: 14px;
        position: relative;
    }
    .frame-295922870 {
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        justify-content: space-between;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .product-name {
        color: var(--text-text-primary, #ffffff);
        text-align: left;
        font-family: "OpenSans-Regular", sans-serif;
        font-size: 14px;
        line-height: 14px;
        font-weight: 400;
        position: relative;
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        text-overflow: ellipsis;
        overflow: hidden;
    }
    .frame-295922854 {
        display: flex;
        flex-direction: row;
        gap: 12px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .price {
        color: var(--text-text-secondary, #8c8c8c);
        text-align: left;
        font-family: "OpenSans-Regular", sans-serif;
        font-size: 14px;
        line-height: 18px;
        font-weight: 400;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }
    ._1-500-nok {
        text-align: right;
        position: relative;
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }
    ._1-500-nok-span {
        color: var(--text-text-primary, #ffffff);
        font-family: "OpenSans-SemiBold", sans-serif;
        font-size: 16px;
        line-height: 22px;
        font-weight: 600;
    }
    ._1-500-nok-span2 {
        color: #ffffff;
        font-family: var(--text-primarytext-font-family, "OpenSans-Regular", sans-serif);
        font-size: var(--text-primarytext-font-size, 16px);
        line-height: var(--text-primarytext-line-height, 22px);
        font-weight: var(--text-primarytext-font-weight, 400);
    }
    ._1-500-nok-span3 {
        color: var(--text-text-secondary, #8c8c94);
        font-family: "OpenSans-Regular", sans-serif;
        font-size: 12px;
        line-height: 17px;
        font-weight: 400;
    }
    .frame-295922872 {
        display: flex;
        flex-direction: row;
        gap: 12px;
        align-items: flex-start;
        justify-content: flex-end;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .btn-mini {
        background: var(--buttons-button-quaternary, rgba(166, 166, 166, 0.1));
        border-radius: 52px;
        padding: 4px 16px 4px 16px;
        display: flex;
        flex-direction: row;
        gap: 4px;
        align-items: center;
        justify-content: center;
        flex: 1;
        height: 32px;
        position: relative;
        cursor: pointer;
    }
    .eye {
        flex-shrink: 0;
        width: 12px;
        height: 12px;
        position: relative;
        overflow: visible;
    }
    .button {
        color: var(--text-text-primary, #ffffff);
        text-align: left;
        font-family: var(--buttons-buttontext-font-family, "OpenSans-Regular", sans-serif);
        font-size: var(--buttons-buttontext-font-size, 14px);
        line-height: var(--buttons-buttontext-line-height, 18px);
        font-weight: var(--buttons-buttontext-font-weight, 400);
        position: relative;
        cursor: pointer;
    }
    .frame-29476 {
        flex-shrink: 0;
        width: 32px;
        height: 32px;
        position: relative;
        cursor: pointer;
    }
    .ellipse-86 {
        background: var(--wrap-wrap-red, rgba(255, 0, 0, 0.1));
        border-radius: 50%;
        width: 32px;
        height: 32px;
        position: absolute;
        left: 0px;
        top: 0px;
        backdrop-filter: blur(15px);
    }
    .frame-29475 {
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: center;
        width: 20px;
        height: 18px;
        position: absolute;
        left: calc(50% - 10px);
        top: calc(50% - 9px);
    }
    .trash-03 {
        flex-shrink: 0;
        width: 18px;
        height: 18px;
        position: relative;
        overflow: visible;
    }
    ._1-500-nok-span4 {
        color: var(--text-text-primary, #ffffff);
        font-family: "OpenSans-SemiBold", sans-serif;
        font-size: 16px;
        line-height: 22px;
        font-weight: 600;
    }
    ._1-500-nok-span5 {
        color: #ffffff;
        font-family: var(--text-primarytext-font-family, "OpenSans-Regular", sans-serif);
        font-size: var(--text-primarytext-font-size, 16px);
        line-height: var(--text-primarytext-line-height, 22px);
        font-weight: var(--text-primarytext-font-weight, 400);
    }
    ._1-500-nok-span6 {
        color: var(--text-text-secondary, #8c8c94);
        font-family: "OpenSans-Regular", sans-serif;
        font-size: 12px;
        line-height: 17px;
        font-weight: 400;
    }
    .eye2 {
        flex-shrink: 0;
        width: 12px;
        height: 12px;
        position: relative;
        overflow: visible;
    }
    .trash-032 {
        flex-shrink: 0;
        width: 18px;
        height: 18px;
        position: relative;
        overflow: visible;
    }
    .frame-2959228722 {
        display: flex;
        flex-direction: row;
        gap: 16px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    ._1-500-nok-span7 {
        color: var(--text-text-primary, #ffffff);
        font-family: "OpenSans-SemiBold", sans-serif;
        font-size: 16px;
        line-height: 22px;
        font-weight: 600;
    }
    ._1-500-nok-span8 {
        color: #ffffff;
        font-family: var(--text-primarytext-font-family, "OpenSans-Regular", sans-serif);
        font-size: var(--text-primarytext-font-size, 16px);
        line-height: var(--text-primarytext-line-height, 22px);
        font-weight: var(--text-primarytext-font-weight, 400);
    }
    ._1-500-nok-span9 {
        color: var(--text-text-secondary, #8c8c94);
        font-family: "OpenSans-Regular", sans-serif;
        font-size: 12px;
        line-height: 17px;
        font-weight: 400;
    }
    .eye3 {
        flex-shrink: 0;
        width: 12px;
        height: 12px;
        position: relative;
        overflow: visible;
    }
    .trash-033 {
        flex-shrink: 0;
        width: 18px;
        height: 18px;
        position: relative;
        overflow: visible;
    }
    ._1-500-nok-span10 {
        color: var(--text-text-primary, #ffffff);
        font-family: "OpenSans-SemiBold", sans-serif;
        font-size: 16px;
        line-height: 22px;
        font-weight: 600;
    }
    ._1-500-nok-span11 {
        color: #ffffff;
        font-family: var(--text-primarytext-font-family, "OpenSans-Regular", sans-serif);
        font-size: var(--text-primarytext-font-size, 16px);
        line-height: var(--text-primarytext-line-height, 22px);
        font-weight: var(--text-primarytext-font-weight, 400);
    }
    ._1-500-nok-span12 {
        color: var(--text-text-secondary, #8c8c94);
        font-family: "OpenSans-Regular", sans-serif;
        font-size: 12px;
        line-height: 17px;
        font-weight: 400;
    }
    .eye4 {
        flex-shrink: 0;
        width: 12px;
        height: 12px;
        position: relative;
        overflow: visible;
    }
    .trash-034 {
        flex-shrink: 0;
        width: 18px;
        height: 18px;
        position: relative;
        overflow: visible;
    }
    .rectangle-231 {
        background: var(--color-status-red-100, #ff0000);
        border-radius: 0px 8px 0px 10px;
        width: 45px;
        height: 21px;
        position: absolute;
        right: -2px;
        top: -0.01px;
    }
    ._30 {
        color: #ffffff;
        text-align: center;
        font-family: "OpenSans-SemiBold", sans-serif;
        font-size: 14px;
        line-height: 0px;
        font-weight: 600;
        position: absolute;
        right: 4px;
        top: 10.99px;
    }
    .discountPrice {
        font-size: 14px;
        font-weight: 400;
        color: #ff0000;
        text-decoration: line-through;
    }
`;

const CheckoutItemCard = ({ item, cartCount }) => {
    const { shopperBagItem, setShopperBagItem, setShopperBagID, shopperBagID } = React.useContext(AppContext);
    const { setShowRightCheckoutPanel, setShowInfoPopup } = React.useContext(LayoutContext);

    const card = cartCount;

    const onItemRemovePopup = item => {
        onRemoveFromCart(item);
    };

    // Function to remove item from allData if it matches iem
    const removeItemMethod = (items, removeItem) => {
        return items.filter(item => {
            return !(
                item.GTINbarcode === removeItem.GTINbarcode &&
                item.labelBrandID === removeItem.labelBrandID &&
                item.deliveryOption === removeItem.deliveryOption &&
                item.deliveryCost === removeItem.deliveryCost &&
                item.originalItemPrice === removeItem.originalItemPrice &&
                item.currentItemPrice === removeItem.currentItemPrice &&
                item.BOimageID === removeItem.BOimageID &&
                // Compare storeID if it exists in both, or handle cases where storeID is absent
                (item.storeID === removeItem.storeID?._id ||
                    item.storeID?._id === removeItem.storeID?._id ||
                    (!item.storeID && !removeItem.storeID)) &&
                // Compare deliveryInstructions (key fields)
                item.deliveryInstructions.latitude === removeItem.deliveryInstructions.latitude &&
                item.deliveryInstructions.longitude === removeItem.deliveryInstructions.longitude &&
                item.deliveryInstructions.address === removeItem.deliveryInstructions.address &&
                item.deliveryInstructions.doorNumber === removeItem.deliveryInstructions.doorNumber &&
                item.deliveryInstructions.postcode === removeItem.deliveryInstructions.postcode
            );
        });
    };
    const getUserShopperBag = BOthebotAccountID => {
        Library.makePostRequest("getShopperBagsData", { BOthebotAccountID: BOthebotAccountID })
            .then(res => {
                const { data } = res;
                const shopperBags = data.data;
                if (shopperBags.length) {
                    shopperBags.forEach(bag => {
                        setShopperBagID(bag._id);
                        setShopperBagItem(bag.items);
                    });
                } else {
                    setShopperBagID(null);
                    setShopperBagItem([]);
                }
            })
            .catch(error => {
                console.error("Error fetching shopper bags data:", error);
            });
    };
    // delete function
    const onRemoveFromCart = removeItem => {
        if (localStorage.getItem("pid")) {
            const formattedData = removeItemMethod(transformData(shopperBagItem), removeItem);
            const payload = {
                shopperBagID: shopperBagID,
                shopperBag: {
                    items: formattedData
                }
            };
            if (card === 1) {
                Library.makePostRequest("deleteShopperBag", { shopperBagID: shopperBagID }, false).then(res => {
                    const { data } = res;
                    if (data?.status === 200) {
                        getUserShopperBag(localStorage.getItem("pid"));
                        setShowRightCheckoutPanel(false);
                    }
                });
            } else {
                Library.makePostRequest("updateShopperBag", payload, false).then(res => {
                    const { data } = res;
                    if (data?.status === 200 && typeof data?.message === "string") {
                        getUserShopperBag(localStorage.getItem("pid"));
                    }
                });
            }
        } else {
            const shopperLocalBag = localStorage.getItem("shopperBag");
            const existingBag = JSON.parse(shopperLocalBag);
            if (existingBag?.shopperBag?.items?.length === 1) {
                localStorage.removeItem("shopperBag");
                setShopperBagItem([]);
                setShowRightCheckoutPanel(false);
            } else {
                const formattedData = removeItemMethod(existingBag?.shopperBag?.items, removeItem);
                existingBag.shopperBag.items = formattedData;
                setShopperBagItem(formattedData);
                localStorage.setItem("shopperBag", JSON.stringify(existingBag));
            }
        }
    };
    return (
        <>
            {card === 1 ? (
                <SingleCheckoutItemCard setShowInfoPopup={setShowInfoPopup} item={item} onItemRemovePopup={onItemRemovePopup} />
            ) : (
                <MultipleCheckoutItemCard item={item} onItemRemovePopup={onItemRemovePopup} />
            )}
        </>
    );
};

export default CheckoutItemCard;
const SingleCheckoutItemCard = ({ setShowInfoPopup, item, onItemRemovePopup }) => {
    const color = item?.productDetails?.colorCode?.startsWith("#")
        ? item?.productDetails?.colorCode
        : `#${item?.productDetails?.colorCode}`;
    return (
        <CheckoutItemCardStyles>
            <div className="product-item-card">
                <div
                    className="image2"
                    style={{
                        backgroundImage: `
                        linear-gradient(346.51deg, rgba(0, 0, 0, 0) 75.07%, rgba(0, 0, 0, 0.4) 85.18%),
                        url(${item?.productDetails?.images[0]?.URL})
                    `,
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "cover",
                        height: "300px"
                    }}>
                    <div className="chips">
                        <div className="x-1">x{item?.quantity || 1}</div>
                    </div>
                    <div className="chips2">
                        <div
                            className="ellipse-243"
                            style={{
                                backgroundColor: color
                            }}></div>
                        <div className="m">{item?.productDetails?.size}</div>
                    </div>
                    <div className="frame-295922389" style={{ width: "100px", height: "36px", padding: "6px 12px" }}>
                        <img className="samsoe-samsoe-logo-white-3" src={item?.brandDetails?.logos} alt="" />
                    </div>
                    {item?.itemDiscountPercentage ? (
                        <>
                            <div className="rectangle-231"></div>
                            <div className="_30">{item?.itemDiscountPercentage}%</div>
                        </>
                    ) : null}
                </div>
                <div className="frame-295922778">
                    <div className="frame-295922816">
                        <div className="frame-295922869">
                            <div className="frame-295922870">
                                <div className="product-name">{item?.productDetails?.name}</div>
                            </div>
                        </div>
                        <div className="frame-295922854">
                            <div className="price">Price:</div>
                            <div className="_1-500-nok">
                                <span style={{ display: "flex", alignItems: "center", gap: "2px" }}>
                                    {item?.itemDiscountPercentage ? (
                                        <span className="_1-500-nok-span">
                                            <span className="discountPrice">{Formatter.formatPrice(item?.originalItemPrice)}</span>
                                            &nbsp;
                                            <span>{Formatter.formatPrice(item?.currentItemPrice)}</span>
                                        </span>
                                    ) : (
                                        <span className="_1-500-nok-span">{Formatter.formatPrice(item?.originalItemPrice)}</span>
                                    )}
                                    <span className="_1-500-nok-span"></span>
                                    <span className="_1-500-nok-span2"></span>
                                    <span className="_1-500-nok-span3">NOK</span>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="frame-295922872">
                        <div
                            className="btn-mini"
                            onClick={() => {
                                setShowInfoPopup({
                                    state: true,
                                    data: item,
                                    lastOpenState: true
                                });
                            }}>
                            <PasswordEyeHideActive
                                className="frame-29057 cursor-pointer"
                                style={{
                                    height: "15px",
                                    width: "15px"
                                }}
                            />
                            <div className="button">See info</div>
                        </div>
                        <div className="frame-29476">
                            <div className="ellipse-86"></div>
                            <div
                                className="frame-29475"
                                onClick={() => {
                                    onItemRemovePopup(item);
                                }}>
                                <img className="trash-03" src={WarnIcon} alt="" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </CheckoutItemCardStyles>
    );
};

const MultipleCheckoutItemCard = ({ item, onItemRemovePopup }) => {
    const BOTagData = item;
    const { setShowInfoPopup } = React.useContext(LayoutContext);
    const color = BOTagData?.productDetails?.colorCode?.startsWith("#")
        ? BOTagData?.productDetails?.colorCode
        : `#${BOTagData?.productDetails?.colorCode}`;
    return (
        <MultipleCheckoutItemCardStyles>
            <div className="frame-29737">
                <div className="frame-295922868">
                    <div className="frame-295922871">
                        <div className="product-item-card">
                            <div
                                style={{
                                    backgroundImage: `
                                    linear-gradient(346.51deg, rgba(0, 0, 0, 0) 75.07%, rgba(0, 0, 0, 0.4) 85.18%),
                                    url(${BOTagData?.productDetails?.images[0]?.URL})
                                `,
                                    backgroundPosition: "center",
                                    backgroundRepeat: "no-repeat",
                                    backgroundSize: "cover"
                                }}
                                className="image">
                                <div className="chips3">
                                    <div className="x-1">x{BOTagData?.quantity || 1}</div>
                                </div>
                                <div className="chips4">
                                    <div
                                        className="ellipse-243"
                                        style={{
                                            background: `${color}`
                                        }}></div>
                                    <div className="m">{BOTagData?.productDetails?.size}</div>
                                </div>
                                <div className="frame-295922389" style={{ width: "100px", height: "36px", padding: "6px 12px" }}>
                                    <img className="samsoe-samsoe-logo-white-3" src={BOTagData?.brandDetails?.logos} alt="" />
                                </div>
                                {BOTagData?.itemDiscountPercentage ? (
                                    <>
                                        <div className="rectangle-231"></div>
                                        <div className="_30">{BOTagData?.itemDiscountPercentage}%</div>
                                    </>
                                ) : null}
                            </div>
                            <div className="frame-295922778">
                                <div className="frame-295922816">
                                    <div className="frame-295922869">
                                        <div className="frame-295922870">
                                            <div className="product-name">{BOTagData?.productDetails?.name}</div>
                                        </div>
                                    </div>
                                    <div className="frame-295922854">
                                        <div className="price">Price:</div>
                                        <div className="_1-500-nok">
                                            <span style={{ display: "flex", alignItems: "center", gap: "2px" }}>
                                                {BOTagData?.itemDiscountPercentage ? (
                                                    <span className="_1-500-nok-span">
                                                        <span className="discountPrice">
                                                            {Formatter.formatPrice(BOTagData?.originalItemPrice)}
                                                        </span>
                                                        &nbsp;
                                                        {Formatter.formatPrice(BOTagData?.currentItemPrice)}
                                                    </span>
                                                ) : (
                                                    <span className="_1-500-nok-span">
                                                        {Formatter.formatPrice(BOTagData?.originalItemPrice)}
                                                    </span>
                                                )}
                                                <span className="_1-500-nok-span2"></span>
                                                <span className="_1-500-nok-span3">NOK</span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div className="frame-295922872">
                                    <div
                                        className="btn-mini"
                                        onClick={() => {
                                            setShowInfoPopup({
                                                state: true,
                                                data: item,
                                                lastOpenState: true
                                            });
                                        }}>
                                        <PasswordEyeHideActive
                                            className="frame-29057 cursor-pointer"
                                            style={{
                                                height: "15px",
                                                width: "15px"
                                            }}
                                        />
                                        <div className="button">See info</div>
                                    </div>
                                    <div className="frame-29476">
                                        <div className="ellipse-86"></div>
                                        <div
                                            className="frame-29475"
                                            onClick={() => {
                                                onItemRemovePopup(item);
                                            }}>
                                            <img className="trash-03" src={WarnIcon} alt="" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </MultipleCheckoutItemCardStyles>
    );
};
